import Input from "@/app/components/ui/Inputs/Input";
import useFormValidations from "@/app/hooks/useFormValidations";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { IAddVendorBasicInfoFormFields } from "..";

const SAP_CODE_REGEX = /^[A-Za-z0-9/-]+$/;
const PAYMENT_TERM_REGEX = /^\d+$/;

const VendorBasicDetailsFormComponent: React.FC<{
  basicInfoFormHook: UseFormReturn<IAddVendorBasicInfoFormFields, any>;
}> = ({ basicInfoFormHook }) => {
  const { forEmail, forMobile, forOnlyAlphabet, forAllAcceptWithOutStartWithDotAndSpace } = useFormValidations();

  const validateAlternateMobile = () => {
    basicInfoFormHook.trigger(`primary_phone`).then((isValid) => {
      if (isValid) {
        if (basicInfoFormHook.getValues("primary_phone") === basicInfoFormHook.getValues("alternate_phone")) {
          basicInfoFormHook.setError("alternate_phone", {
            type: "validate",
            message: "",
          });
        }
      }
    });
  };

  return (
    <form className="mt-4 sm:mt-8 bg-white py-4 rounded-md">
      <p className="text-md font-semibold">Basic Details</p>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Vendor Name (Trade)</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <Input
          errorMessages={[
            { message: "Trade name is required", type: "required" },
            forAllAcceptWithOutStartWithDotAndSpace.errors,
          ]}
          fieldError={basicInfoFormHook.formState.errors.trade_name}
          placeholder="Enter Trade Name"
          register={basicInfoFormHook.register("trade_name", {
            required: true,
            ...forAllAcceptWithOutStartWithDotAndSpace.validations,
            // onBlur: () => basicInfoFormHook.trigger(`trade_name`),
            onChange: () => basicInfoFormHook.trigger(`trade_name`),
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("trade_name", e.target?.value);
            basicInfoFormHook.clearErrors("trade_name");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Vendor Name (Legal)</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <Input
          errorMessages={[
            { message: "Legal name is required", type: "required" },
            forAllAcceptWithOutStartWithDotAndSpace.errors,
          ]}
          fieldError={basicInfoFormHook.formState.errors.legal_name}
          placeholder="Enter Legal Name"
          register={basicInfoFormHook.register("legal_name", {
            required: true,
            ...forAllAcceptWithOutStartWithDotAndSpace.validations,
            // onBlur: () => basicInfoFormHook.trigger(`legal_name`),
            onChange: () => basicInfoFormHook.trigger(`legal_name`),
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("legal_name", e.target?.value);
            basicInfoFormHook.clearErrors("legal_name");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Vendor Email</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <Input
          errorMessages={[forEmail.errors, { message: "Vendor email is required", type: "required" }]}
          fieldError={basicInfoFormHook.formState.errors.email}
          placeholder="Enter Vendor Email"
          register={basicInfoFormHook.register("email", {
            required: true,
            ...forEmail.validations,
            maxLength: 30,
            // onBlur: () => basicInfoFormHook.trigger(`email`),
            onChange: () => basicInfoFormHook.trigger(`email`),
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("email", e.target?.value);
            basicInfoFormHook.clearErrors("email");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Vendor Phone</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <Input
          errorMessages={[
            forMobile.errors,
            { message: "Max 10", type: "maxLength" },
            { message: "Vendor primary phone is required", type: "required" },
          ]}
          fieldError={basicInfoFormHook.formState.errors.primary_phone}
          maxLength={10}
          placeholder="Enter Vendor Phone"
          register={basicInfoFormHook.register("primary_phone", {
            required: true,
            maxLength: 10,
            ...forMobile.validations,
            onChange: () => basicInfoFormHook.trigger(`primary_phone`),
            // onBlur: () => {
            //   basicInfoFormHook.trigger("primary_phone");
            // },
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("primary_phone", e.target?.value);
            basicInfoFormHook.clearErrors("primary_phone");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Alternate Number</span>
        </div>
        <Input
          errorMessages={[
            forMobile.errors,
            { message: "Max 10", type: "maxLength" },
            {
              type: "validate",
              message: "Should not be same as primary.",
            },
          ]}
          fieldError={basicInfoFormHook.formState.errors.alternate_phone}
          maxLength={10}
          placeholder="Enter Alternate Number"
          register={basicInfoFormHook.register("alternate_phone", {
            maxLength: 10,
            ...forMobile.validations,
            onChange: () => {
              validateAlternateMobile();
            },
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("alternate_phone", e.target?.value);
            basicInfoFormHook.clearErrors("alternate_phone");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">SAP Code</span>
        </div>
        <Input
          errorMessages={[
            { message: "Only letters, numbers, '/' and '-' allowed (no spaces)", type: "pattern" },
            { message: "Max 20 characters", type: "maxLength" },
          ]}
          fieldError={basicInfoFormHook.formState.errors.sap_code}
          maxLength={20}
          placeholder="Enter SAP Code"
          register={basicInfoFormHook.register("sap_code", {
            maxLength: 20,
            pattern: SAP_CODE_REGEX,
            onChange: () => basicInfoFormHook.trigger(`sap_code`),
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("sap_code", e.target?.value);
            basicInfoFormHook.clearErrors("sap_code");
          }}
        />
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">Payment Term (Days)</span>
        </div>
        <Input
          errorMessages={[
            { message: "Only whole numbers allowed", type: "pattern" },
            { message: "Min 1 day", type: "min" },
            { message: "Max 1000 days", type: "max" },
          ]}
          fieldError={basicInfoFormHook.formState.errors.payment_term}
          maxLength={4}
          inputMode="numeric"
          placeholder="Enter Payment Term (1-1000 days)"
          register={basicInfoFormHook.register("payment_term", {
            pattern: PAYMENT_TERM_REGEX,
            min: 1,
            max: 1000,
            onChange: () => basicInfoFormHook.trigger(`payment_term`),
          })}
          className="border-slate-400 rounded-md w-full sm:w-[300px] h-9 text-sm"
          inputClassName="h-[38px] rounded-md"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            basicInfoFormHook?.setValue("payment_term", e.target?.value);
            basicInfoFormHook.clearErrors("payment_term");
          }}
        />
      </div>
    </form>
  );
};

export default VendorBasicDetailsFormComponent;
